import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { menuItems } from "../Constants/menuItems";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BrowseCategory = () => {
  const [browseCategories, setBrowseCategories] = useState([]);
  const [formData, setFormData] = useState({
    collectionName: "",
    category: "",
    routeTo: "",
    image: null,
  });
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleDelete = (_id) => {
    setSelectedVideoId(_id);
    setShowConfirm(true);
  };

  // Handle delete
  const confirmDelete = async (id) => {
    try {
      await axios.delete(`${backend_url}/api/browsecategory/${id}`);
      setShowConfirm(false);
      toast.success("Category deleted Successfully");
      fetchBrowseCategories(); //Refresh after deletion
    } catch (error) {
      toast.error("Error deleting arrival:", error);
    }
  };

  // Fetch all new arrivals
  useEffect(() => {
    fetchBrowseCategories();
  }, []);

  const fetchBrowseCategories = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(`${backend_url}/api/browsecategory`);
      setBrowseCategories(response.data);
    } catch (error) {
      toast.error("Error fetching category:", error);
    } finally {
      setLoading(false); // end loading
    }
  };
  // Handle form input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      const file = files[0];
      setFormData({ ...formData, image: file });
      if (file) {
        setPreviewImage(URL.createObjectURL(file));
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Handle category change and filter route options
  const handleCategoryChange = (e) => {
    const selected = e.target.value;
    setSelectedCategory(selected);
    setFormData({ ...formData, category: selected });

    if (selected) {
      const selectedCategory = menuItems.find(
        (item) => item.value === selected
      );

      if (selectedCategory && selectedCategory.dropdown) {
        // Flatten dropdown and subcategories
        const options = selectedCategory.dropdown.flatMap((item) => {
          if (item.value === null) {
            return [
              { label: `-- ${item.label} --`, value: null },
              ...(item.subcategories || []),
            ];
          } else {
            return item;
          }
        });

        setCategoryOptions(options);
      } else {
        setCategoryOptions([]);
      }
    } else {
      setCategoryOptions([]);
    }
  };

  // Add or update variety
  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!editingId && formData.image && formData.image.size > 1024 * 1024) {
    //     toast.error("Image size should not exceed 1 MB");
    //     return;
    // }

    const data = new FormData();
    data.append("collectionName", formData.collectionName);
    data.append("routeTo", formData.routeTo);
    data.append("image", formData.image);
    data.append("category", formData.category);

    try {
      if (editingId) {
        await axios.put(`${backend_url}/api/browsecategory/${editingId}`, data);
        toast.success("Category Updated Successfully");
      } else {
        await axios.post(`${backend_url}/api/browsecategory`, data);
        toast.success("Category Added Successfully");
      }
      fetchBrowseCategories();
      closeModal();
    } catch (error) {
      toast.error("Error saving for category:", error);
    }
  };

  // Handle edit
  const handleEdit = (browsecategory) => {
    setFormData({
      collectionName: browsecategory.collectionName,
      routeTo: browsecategory.routeTo,
      image: null, // Don't directly assign URL to file
      category: browsecategory.category,
    });

    setPreviewImage(browsecategory.image); // <-- Add this line

    setSelectedCategory(browsecategory.category);

    // Generate subcategories for Route To
    const selectedCategory = menuItems.find(
      (item) => item.value === browsecategory.category
    );

    if (selectedCategory && selectedCategory.dropdown) {
      const options = selectedCategory.dropdown.flatMap((item) => {
        if (item.value === null) {
          return [
            { label: `-- ${item.label} --`, value: null },
            ...(item.subcategories || []),
          ];
        } else {
          return item;
        }
      });

      setCategoryOptions(options);
    } else {
      setCategoryOptions([]);
    }

    setEditingId(browsecategory._id);
    setShowModal(true);
  };

  // Close modal and reset form
  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData({ routeTo: "", image: null, category: "", collectionName: "" });
    setSelectedCategory("");
    setCategoryOptions([]);
    setPreviewImage(null);
  };

  const formatText = (text) =>
    text.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
      <div className="variety-admin">
        <div className="headerSections">
          <div className="head-title">Browse by Category</div>
          {browseCategories.length < 8 && (
            <button className="add-btn" onClick={() => setShowModal(true)}>
              + Add Category
            </button>
          )}
        </div>

        {/* Popup Modal */}
        {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h2>{editingId ? "Edit Category" : "Add Category"}</h2>
              <form onSubmit={handleSubmit} className="variety-form">
                <div className="form-group">
                  <label htmlFor="collectionName">Collection Name</label>
                  <input
                    type="text"
                    id="collectionName"
                    name="collectionName"
                    maxLength={20}
                    value={formData.collectionName}
                    onChange={handleChange}
                    placeholder="Enter Collection Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="category">Category</label>
                  <select
                    id="category"
                    name="category"
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    required
                  >
                    <option value="">Select a category</option>
                    {menuItems.map((category) => (
                      <option key={category.value} value={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Route To Dropdown */}
                <div className="form-group">
                  <label htmlFor="routeTo">Route To</label>
                  <select
                    id="routeTo"
                    name="routeTo"
                    value={formData.routeTo}
                    onChange={handleChange}
                    required
                    disabled={!selectedCategory}
                  >
                    <option value="">Select a route</option>
                    {categoryOptions.map((option) =>
                      option.value ? (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ) : (
                        <option key={option.label} value="" disabled>
                          {option.label}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="image">Image</label>

                  {/* Hide original file input */}
                  <input
                    type="file"
                    id="image"
                    name="image"
                    onChange={handleChange}
                    accept="image/*"
                    required={!editingId}
                    style={{ display: "none" }}
                  />

                  {/* Styled label as file input button */}
                  <label htmlFor="image" className="custom-file-label">
                    Choose Image
                  </label>

                  {/* Preview */}
                  {previewImage && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "10px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  )}
                </div>

                <div className="form-buttons">
                  <button type="submit" className="submit-btn">
                    {editingId ? "Update" : "Add"}
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* List Table */}
        <table className="variety-table">
          <thead>
            <tr>
              <th>Collection Name</th>
              <th>Category</th>
              <th>Route To</th>
              <th>Image</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {browseCategories.map((browseCategory) => (
              <tr key={browseCategory._id}>
                <td>{browseCategory.collectionName}</td>
                <td>{formatText(browseCategory.category)}</td>
                <td>{formatText(browseCategory.routeTo)}</td>
                <td>
                  <img
                    src={`${browseCategory.image}`}
                    alt={browseCategory.collectionName}
                  />
                </td>
                <td>
                  <button onClick={() => handleEdit(browseCategory)}>
                    Edit
                  </button>
                  <button onClick={() => handleDelete(browseCategory._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Confirmation Popup */}
      {showConfirm && (
        <div className="confirm-popup">
          <div className="confirm-content">
            <p>Are you sure you want to delete this category?</p>
            <div className="popup-actions">
              <button
                onClick={() => confirmDelete(selectedVideoId)}
                className="confirm-btn"
              >
                Confirm
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default BrowseCategory;
